import React, { useState } from 'react'
import { Radio } from 'element-react'

const RadioSG = () => {
    // Constructors
    const [radioGroup, setRadioGroup] = useState(3)
    const [radioButtonGroup, setRadioButtonGroup] = useState('New York')

    // OnChange Methods
    const radioGroupChange = value => {
        setRadioGroup(value)
    }
    const radioButtonGroupChange = value => {
        setRadioButtonGroup(value)
    }

    return (
        <div>
            {/* Radio Group ============================  */}
            <h4 className="sg-heading">Radio Group</h4>
            <Radio.Group
                value={radioGroup}
                onChange={val => radioGroupChange(val)}
            >
                <Radio value="3">Option A</Radio>
                <Radio value="6">Option B</Radio>
                <Radio value="9">Option C</Radio>
            </Radio.Group>

            {/* Radio Button Group ============================  */}
            <h4 className="sg-heading">Radio Button Group</h4>
            <Radio.Group
                value={radioButtonGroup}
                onChange={val => radioButtonGroupChange(val)}
            >
                <Radio.Button value="New York" />
                <Radio.Button value="Washington" />
                <Radio.Button value="Los Angeles" />
                <Radio.Button value="Chicago" />
            </Radio.Group>
        </div>
    )
}

export default RadioSG
